import ImagesIcon from '@/assets/images.svg?react'
import ClickWrapper from '@/components/ClickWrapper'
import { selectFiles } from '@/utils/file'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import styles from './PictureAttachmentPicker.module.css'

export interface PictureAttachmentPickerProps extends Omit<
	HTMLAttributes<HTMLDivElement>,
	'onSelect'
> {
	onSelect?: (files: File[]) => void
	disabled?: boolean
}

export default function PictureAttachmentPicker({
	disabled,
	onSelect,
	...props
}: PictureAttachmentPickerProps) {
	return (
		<ClickWrapper
			className={styles.root}
			title="图片"
			onClick={() => {
				selectFiles({
					multiple: true,
					accept: 'image/png, image/jpeg',
				}).then((files) => {
					onSelect?.(files)
				})
			}}
		>
			<ImagesIcon className={clsx(styles.icon, disabled && styles.iconDisabled)} />
		</ClickWrapper>
	)
}
